"use strict";

exports.__esModule = true;
exports.createMemoryStorage = createMemoryStorage;
function createMemoryStorage() {
  var state = {};
  return {
    getItem: function getItem(key) {
      return Promise.resolve(state[key]);
    },
    setItem: function setItem(key, value) {
      state[key] = value;
      return Promise.resolve(value);
    },
    removeItem: function removeItem(key) {
      delete state[key];
      return Promise.resolve();
    },
    getAllKeys: function getAllKeys() {
      return Promise.resolve(Object.keys(state));
    }
  };
}

exports.default = createMemoryStorage();


//////////////////
// WEBPACK FOOTER
// ./node_modules/storage-memory/lib/index.js
// module id = 1144
// module chunks = 0